var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 24.5,
    fill: "#FFF0F0",
    stroke: "#FF9999"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 67,
    height: 67,
    rx: 20.5,
    fill: "#FF9999",
    stroke: "#FFF0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0607,
    y: 32.2744,
    width: 8.78761,
    height: 41.5209,
    rx: 1.25,
    transform: "rotate(-45 26.0607 32.2744)",
    stroke: "#FFF0F0",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6279 58.0484L31.0317 61.4522C31.8127 62.2333 33.0791 62.2333 33.8601 61.4522L61.4521 33.8603C62.2331 33.0792 62.2331 31.8129 61.4521 31.0318L58.0483 27.6281L56.9876 28.6887L60.3914 32.0925C60.5867 32.2878 60.5867 32.6044 60.3914 32.7996L32.7995 60.3916C32.6042 60.5868 32.2876 60.5868 32.0924 60.3916L28.6886 56.9878L27.6279 58.0484ZM56.5847 26.2633C55.8208 25.826 54.8299 25.9335 54.1776 26.5858L26.5857 54.1778C25.9334 54.8301 25.8259 55.8209 26.2631 56.5848L56.5847 26.2633Z",
    fill: "#FFF0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrIcon);
export default __webpack_public_path__ + "static/media/err_icon.18a8f8008cd363acbc866001b8888349.svg";
export { ForwardRef as ReactComponent };